import React, { useState, useEffect } from 'react';
import { Button, Input, Label, Dimmer, Loader } from 'semantic-ui-react';
import Checkout from '../index';
import queryString from 'query-string';

const PublicCheckout = (props) => {
    const [invitationId, setInvitationId] = useState('');

    useEffect(() => {
        console.log(props.location.search, 'sssss');
        const { invitationId: lInvitationId } = queryString.parse(props.location.search);
        setInvitationId(lInvitationId);
    }, [props.location.search]);
    return (
        props.match.params &&
        props.match.params.paymentManagerId && (
            <Checkout
                paymentManagerId={props.match.params && props.match.params.paymentManagerId}
                invitationId={invitationId}
            />
        )
    );
};

export default PublicCheckout;
